import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { resetPassword, clearAuthError } from 'store/slices/authSlice';
import AuthPage from 'components/layout/AuthPage/AuthPage';
import { TextInputField, PasswordField } from 'components/forms';
import { createConfirmPasswordRegisterOptions } from 'components/forms/patterns';
import { PrimaryButton, Link } from 'components/buttons/';
import TimedRedirect from 'components/layout/TimedRedirect/TimedRedirect';

function Reset() {
  const dispatch = useDispatch();
  const { loading, error, status } = useSelector((state) => state.auth);
  const { register, handleSubmit, watch, formState: { errors, isDirty } } = useForm({ mode: "onChange" });
  const [searchParams] = useSearchParams();
  const tokenFromUrl = searchParams.get('token');

  useEffect(() => {
    return () => { dispatch(clearAuthError()); };
  }, [dispatch]);

  const onSubmit = (data) => {
    dispatch(resetPassword({
      token: tokenFromUrl || data.token,
      password: data.password,
    }));
  };

  const renderResetForm = () => (
    <>
      {loading && (
        <div className="text-center text-lg text-indigo-400 mb-4">Setting your new password...</div>
      )}
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        {!tokenFromUrl && (
          <TextInputField
            name="token"
            register={register}
            registerOptions={{ required: 'Reset token is required' }}
            errors={errors}
            placeholder="Reset Token"
            labelText="Reset Token"
          />
        )}
        <PasswordField
          register={register}
          errors={errors}
          placeholder="New Password"
          labelText="New Password"
        />
        <PasswordField
          name="repeatPassword"
          register={register}
          registerOptions={createConfirmPasswordRegisterOptions(watch)}
          errors={errors}
          placeholder="Repeat New Password"
          labelText="Repeat New Password"
        />

        <div>
          <PrimaryButton
            type="submit"
            disabled={loading || !isDirty}
            className="flex w-full justify-center"
          >
            {loading ? 'Updating...' : 'Update Password'}
          </PrimaryButton>
        </div>
      </form>
      <p className="mt-10 text-center text-sm/6 text-gray-400">
        Remembered your password?{' '}
        <Link to="/login">Login</Link>
      </p>
    </>
  );

  return (
    <AuthPage title="Change password" error={error}>
      {status
        ? <TimedRedirect url="/login" message={status} delay={3000} />
        : renderResetForm()
      }
    </AuthPage>
  );
}

export default Reset;
